<template>
  <div class="virtual_guard__divider">
    <p class="virtual_guard__phone_prompt_text" v-for="text of promptMessage.split('\n')" :key="text">{{ text }}</p>
    <p class="virtual_guard__phone_prompt_text virtual_guard__bold_text" v-if="steep !== 2 && steep !== 5 && !failed">
      Responde:</p>
    <div class="virtual_guard__actions voice_actions" v-if="steep !== 2 && steep !== 5 && !failed">
      <button class="virtual_guard__button">
        <span>{{ steep === 1 ? 'Si, por favor.' : 'Si, es correcto.' }}</span>
        <span class="virtual_guard__button_icon"><talk-icon></talk-icon></span>
      </button>
      <button class="virtual_guard__button">
        <span>{{ steep === 1 ? 'No, gracias.' : 'No, es incorrecto.' }}</span>
        <span class="virtual_guard__button_icon"><talk-icon></talk-icon></span>
      </button>
    </div>
  </div>
</template>

<script>
import TalkIcon from "@/components/shared/icons/TalkIcon.vue";
import speakText from "@/utils/SpeachSynthesis";
import initSpeechRecognition from "@/utils/SpeachRecognition";

export default {
  name: 'VirtualGuard',
  components: {TalkIcon},
  props: {
    sublocation_id: {
      required: true,
      type: String,
    }
  },
  data() {
    return {
      promptMessage: '',
      phoneNumber: '',
      recognition: null,
      recognitionActive: false,
      isProcessing: false,
      steep: 1,
      counter: 0,
      phoneAttempts: 0,
      maxFails: 3,
      failed: false,
      globalTimeOut: null,
      restartTimeout: null,
      stepCommands: {
        1: ['sí por favor', 'si por favor', 'no gracias'],
        2: [],
        3: ['correcto', 'incorrecto']
      },
      close: false,
    };
  },
  mounted() {
    this.speak('El tiempo de respuesta puede tardar unos minutos más.\n¿Deseas dejar tu número para contactarte más tarde?');
  },
  beforeUnmount() {
  },
  methods: {
    async speak(text) {
      this.promptMessage = text;
      return speakText({
        text,
        onEnd: () => {
          if (!this.close)
            this.initializeSpeechRecognition()
        },
      });
    },
    initializeSpeechRecognition(commands = []) {
      console.log('initialize')
      this.recognition = initSpeechRecognition({
        commands,
        onResult: this.validateResponse
      });
      this.recognition.start();
    },
    validateResponse(response) {
      switch (this.steep) {
        case 1:
          this.validateSteep1(response);
          break;
        case 2:
          this.validateNumber(response);
          break;
        case 3:
          this.numberIsCorrect(response);
          break;
      }
    },
    validateSteep1(response = '') {
      const normalizedResponse = response.toLowerCase().trim();
      if (normalizedResponse.includes('si por favor') || normalizedResponse.includes('sí por favor')) {
        this.steep = 2;
        this.speak('Por favor, mencione su número de teléfono.')
      } else if (normalizedResponse.includes('no gracias')) {
        this.close = true;
        this.speak('Entendido, que tenga un buen día.').then(() => {
          this.$emit('closePhoneValidation');
        });
      } else {
        this.speak('Respuesta invalida\n¿Deseas dejar tu número para contactarte más tarde?');
      }
    },
    validateNumber(result) {
      const digits = result.replace(/\D/g, '');
      if (digits.length > 0) {
        this.phoneNumber = digits;
        this.steep = 3;
        const formattedNumber = this.phoneNumber.split('').join(' ');
        this.speak(`He capturado el número ${formattedNumber}. ¿Es correcto?.`);
      } else {
        if (this.counter < this.maxFails) {
          const self = this;
          this.counter++;
          this.speak('No he podido captar ningún número. Por favor, inténtelo de nuevo.').then(() => {
            self.recognition.start();
          });
        } else {
          this.failed = true;
          this.close = true;
          this.speak('Se han detectado demasiados intentos fallidos. El proceso ha sido cancelado.').then(() => {
            this.$emit('closePhoneValidation');
          });
        }
      }
    },
    numberIsCorrect(response) {
      const normalized = response.toLowerCase().trim();
      if (normalized.includes('si es correcto') || normalized.includes('sí es correcto')) {
        this.savePhoneNumber();
      } else if (normalized.includes('es incorrecto')) {
        this.steep = 2;
        this.counter++;
        if (this.counter > this.maxFails) {
          this.failed = true;
          this.close = true;
          this.$emit('closePhoneValidation');
          return;
        }
        this.speak('Por favor, mencione su número de teléfono.');
      } else {
        const formattedNumber = this.phoneNumber.split('').join(' ');
        this.speak(`Respuesta invalida, He capturado el número ${formattedNumber}. ¿Es correcto?.`);
      }
    },
    savePhoneNumber() {
      const number = Number(this.phoneNumber);
      this.close = true;
      this.speak('Gracias. Hemos guardado su número de teléfono. Le contactaremos pronto.');
      this.close = true;
      try {
        this.$http.get('company_monitorings/get_number_virtual_agent', {
          headers: {
            'X-Device_ID': this.getDeviceId(),
            Authorization: process.env.VUE_APP_JITSI_TOKEN_AUTHORIZATION,
          },
          params: {
            mobile_virtual_agent: number,
            sublocation_id: this.sublocation_id,
          }
        }).then(() => {
          this.$emit('closePhoneValidation');
        });
      } catch (err) {
        console.error(err);
        alert(JSON.stringify(err));
      }
    }
  }
}
</script>